import { AccordionSecondary } from '@snack-uikit/accordion';
import React, { PropsWithChildren } from 'react';
import { useFormContext } from 'react-hook-form';
import { ParsedFilterBlock } from 'src/types/marketplace';
import {
  getFilterCount,
  getFilterTitleWithCount,
} from 'src/utils/marketplace/filter';

import { ResetButton } from '../ResetButton';
import s from './AccordionHead.module.scss';

type Props = PropsWithChildren<
  Pick<ParsedFilterBlock, 'filterKey' | 'titleKey'>
>;

export function AccordionHead({ filterKey, titleKey, children }: Props) {
  const { watch } = useFormContext();

  const selectedFilters = watch(filterKey);

  const count = getFilterCount(selectedFilters);

  return (
    <AccordionSecondary.CollapseBlock
      id={filterKey}
      header={
        <h4 className={s.heading}>
          {getFilterTitleWithCount(titleKey, count)}
        </h4>
      }
      actions={
        count ? (
          <ResetButton titleKey={titleKey} filterKey={filterKey} />
        ) : undefined
      }
    >
      {children}
    </AccordionSecondary.CollapseBlock>
  );
}
